/* =====================================================================
   v2 — Hero başlığı: telefonda satırı tam doldur
   nowrap başlık, kapsayıcının iç genişliğine göre ölçülüp ölçekleniyor.
   vw tabanlı tahmin metin değişince bozulur; ölçüm bozulmaz.
   ===================================================================== */
(function () {
  function fit(heading) {
    var wrap = heading.closest('.v2-wrap') || heading.parentNode;
    if (!wrap) return;

    if (window.innerWidth >= 640) {
      heading.style.fontSize = '';
      return;
    }

    /* Kullanılabilir genişliği .v2-wrap'in iç kutusundan al: başlık nowrap
       olduğu için kendi sütununu şişirebiliyor ve kendini ölçemiyor. */
    var cs = getComputedStyle(wrap);
    var avail = wrap.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (!(avail > 0)) return;

    heading.style.fontSize = '100px';
    var measured = heading.scrollWidth;
    if (!measured) return;

    heading.style.fontSize = Math.floor(((100 * avail) / measured) * 100) / 100 + 'px';
  }

  function fitAll() {
    document.querySelectorAll('[data-v2-fit-heading]').forEach(fit);
  }

  function boot() {
    fitAll();
    window.addEventListener('resize', fitAll, { passive: true });
    window.addEventListener('orientationchange', fitAll);
    /* Yazı tipi geç yüklenirse ölçüm bir kez daha yapılır */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', fitAll);
})();
